export default "__VITE_ASSET__DMoGEjMC__"